__turbopack_context__.v({
  "height-box": "skyscraper-module-scss-module__HcS_gq__height-box",
  "height-skyscraper": "skyscraper-module-scss-module__HcS_gq__height-skyscraper",
  "margin": "skyscraper-module-scss-module__HcS_gq__margin",
});
